import React from "react";
import AssignVendorList from "./AssignVendorList";

/** HOD-only review workflow (separate menu / route from Assigned vendors and Finance review). */
const AssignVendorHodReviewList = () => <AssignVendorList listVariant="hod" />;

export default AssignVendorHodReviewList;
